import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import {
    BASE_URL, getDefaultHeaders, getDynamicHeaders, Entity,
} from '../config';
import { ITextContent } from './types';

export const textAPI = createApi({
    reducerPath: 'text',
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
    endpoints: (build) => ({
        getOffer: build.query<ITextContent, void>({
            query: () => ({
                url: `${Entity.text}/oferta-website`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getPolicy: build.query<ITextContent, void>({
            query: () => ({
                url: `${Entity.text}/privacyfooter`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getSupport: build.query<ITextContent, void>({
            query: () => ({
                url: `${Entity.text}/header-support`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
        getChatGreeting: build.query<ITextContent, void>({
            query: () => ({
                url: `${Entity.text}/new_dialogue`,
                headers: { ...getDefaultHeaders(), ...getDynamicHeaders() },
            }),
        }),
    }),
});
